import React from 'react';
import '../../App.css';
import logo from "../../assets/images/logo.png";
import image1 from "../../assets/images/deactivate/1.png";
import image2 from "../../assets/images/deactivate/2.png";
import image3 from "../../assets/images/deactivate/3.png";
import image4 from "../../assets/images/deactivate/4.png";

const images = [
    {
        src: image1,
        title: "Step 1:",
        description: "Logging into the application and select the 'Other' menu option."
    },
    {
        src: image2,
        title: "Step 2:",
        description: "Choose the option 'Delete account' from the menu."
    },
    {
        src: image3,
        title: "Step 3:",
        description: "In delete account tab click on 'Continue'"
    },
    {
        src: image4,
        title: "Step 4:",
        description: "If you are certain about your decision, click on the 'Delete' button."
    }
];

const Deleteaccount = () => {
    return (
        <div className="login_bg">
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-12 login_wrapper">
                        <div className="login-outer">
                            <div className="">
                                <div className="Main_logo text-center">
                                    <img src={logo} alt="Application Logo" className="logo_login img-fluid" />
                                </div>
                                <div className="w-100">
                                    <h2 className="login_title">Guide to Deleting Your Account</h2>
                                    <div className="image-gallery">
                                        <div className="row text-center">
                                            {images.map((image, index) => (
                                                <div className="col-md-3 col-sm-6 mb-4" key={index}>
                                                    <div className="image-card">

                                                        <h3 className="image-title text-white">{image.title}</h3>
                                                        <p className="image-description text-white">{image.description}</p>
                                                        <img src={image.src} alt={image.title} className="img-fluid" />
                                                        
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Deleteaccount;
